// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import config from '../config'

let env = 'dev';
if (window.location.hostname == 'ourwork-admin.duiyou360.com') {
	env = 'build';
}
console.log(env,'env')

Vue.prototype.frontUrl = config[env].frontUrl;

Vue.config.productionTip = false
import Element from 'element-ui'
import './theme/index.css'
import './main.css'
Vue.use(Element)
/* eslint-disable no-new */





export default new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js